export default function MastPageController()
{
    this.viewport = {};
    var _breakpoints = { lg: 991, md: 767, sm: 575, xs: 320 };
    var _windowScroll = {};
    var _self = this;
    var _debug = false;
    var $body = $("body");

    var isiPhone = function()
    {
        return (
            (navigator.platform.indexOf("iPhone") != -1) ||
            (navigator.platform.indexOf("iPod") != -1)
        );
    };

    this.init = function()
    {
        _setViewport();
        _setWindowScroll();
        _setStickyElements();
        _setNavDropDown();
        _setReadMoreAutoHeight();
        _setSingleTabs();
        _ajaxBeforeSendHook();
        _initEvents();
        _changeLazyLoadImages();
        _followBasketLink();
        _initAccordeonsForFilters();
        _initFourItemQuestions();
        // _scrollReverter();
    };

    var mobileCheck = function()
    {
        var check = false;

        (function(a)
        {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    var _scrollReverter = function()
    {
        if (mobileCheck())
        {
            $(".listen_stickyElement").each(function()
            {
                var $element = $(this).children(":first");

                $element.addClass("mod_isFix");
            });
            $("[aria-controls=\"searchBox\"]:first").click(function()
            {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                setTimeout(function()
                {
                    window.scrollTo(scrollLeft, scrollTop);
                }, 500);
            });
        }
    };

    this.resize = function()
    {
        if (_debug === true)
        {
            console.log("this.resize");
        }
        _setViewport();
        _setStickyElements();
        _setNavDropDown();
        _setReadMoreAutoHeight();
        _changeLazyLoadImages();
    };

    this.touchend = function()
    {
        if (_debug === true)
        {
            console.log("this.touchend");
        }
        _setReadMoreAutoHeight();
    };

    this.scroll = function()
    {
        if (_debug === true)
        {
            console.log("this.scroll");
        }
        if (isiPhone())
        {
            _setStickyElements();
            _setViewport();
            _setWindowScroll();
            _setNavDropDown();
        }
        else
        {
            _setViewport();
            _setWindowScroll();
            _setStickyElements();
            _setNavDropDown();
        }
    };

    this.getWindowScroll = function()
    {
        return _windowScroll;
    };

    var _initAccordeonsForFilters = function()
    {
        var headings = $(".look_filterOverrides h3, .look_filterOverrides .card .h3");

        headings.each(function()
        {
            var self = $(this);

            self.addClass("look_accordeonToggler");
            var nextElement = self.next();

            nextElement.addClass("look_accordeonContainer");
            self.click(function()
            {

                // On Mobile close others first
                if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768)
                {
                    $(".findologic-container .look_accordeonToggler").not(self).removeClass("look_isVisible");
                    $(".findologic-container .look_accordeonContainer").not(nextElement).removeClass("look_isVisible");
                }

                self.toggleClass("look_isVisible");
                nextElement.toggleClass("look_isVisible");
            });

            if (nextElement.hasClass("selected-tag-list"))
            {
                var filterWrapper = nextElement.find(".selected-filters:first");

                if (filterWrapper.length > 0)
                {
                    if (filterWrapper.children().length > 0)
                    {
                        self.toggleClass("look_isVisible");
                        nextElement.toggleClass("look_isVisible");
                    }
                }
            }

            // open on Mobile/desktop
            if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 768)
            {
                self.addClass("look_isVisible");
                nextElement.addClass("look_isVisible");
            }
        });

        return 0;
    };

    var _ajaxBeforeSendHook = function()
    {
        $.ajaxSetup({
            beforeSend: function(jqXHR, settings)
            {
                settings.data = _overridePostContactForm(jqXHR, settings);
                return true;
            }
        });
    };

    var _overridePostContactForm = function(jqXHR, settings)
    {
        var returnData = settings.data;

        if (settings.url === "/rest/io/customer/contact/mail")
        {

            var postData = settings.data;

            postData = postData.replace("template=Ceres%3A%3ACustomer.Components.Contact.ContactMail", "template=CeresHofer%3A%3ACustomer.Components.Contact.ContactMail");

            if (postData.indexOf("contactData%5Bsubject%5D=&") >= 0)
            {
                postData = postData.replace("contactData%5Bsubject%5D=&", "contactData%5Bsubject%5D=Kontaktanfrage&");
            }

            returnData = postData;
        }
        return returnData;
    };

    var _initEvents = function()
    {
        $body.off("click.eqHReadMore").on("click.eqHReadMore", ".do_toggleEqHReadMore", function()
        {
            var $element = $(this);
            var $wrapper = $element.closest(".listen_eqHReadMore");

            if ($wrapper.length > 0)
            {
                if ($wrapper.hasClass("show"))
                {
                    $wrapper.removeClass("show");
                }
                else
                {
                    $wrapper.addClass("show");
                }
            }
        });

        $body.off("click.triggerTarget").on("click.triggerTarget", ".do_trigger", function()
        {
            var $element = $(this);
            var $target = (typeof ($element.attr("data-target")) !== "undefined") ? $($element.attr("data-target")) : false;
            var type = (typeof ($element.attr("data-type")) !== "undefined") ? type : "click";

            if ($target !== false && $target.length > 0)
            {
                $target.trigger(type);
            }
        });

        $body.on("click", ".do_toggleMobileTab", function()
        {
            var $element = $(this);
            var $parent = $element.parent();
            var $wrapper = $parent.parent();
            var isVisible = $parent.hasClass("active");

            $wrapper.find(".tab-pane").removeClass("active");
            if (!isVisible)
            {
                $parent.addClass("active");
            }
        });
    };

    var _setStickyElements = function()
    {
        if (mobileCheck())
        {

        }
        else
        {
            $(".listen_stickyElement").each(function()
            {
                var type = "top";
                var $wrapper = $(this);
                var $element = $wrapper.children(":first");
                var offset = 0;

                if ($element.length > 0)
                {
                    $element.removeClass("mod_isFix");
                    $wrapper.css("height", $element.outerHeight(true));

                    offset = parseInt($element.offset().top);

                    if (_windowScroll.top > 0 && offset <= parseInt(_windowScroll.top))
                    {
                        $element.addClass("mod_isFix");
                    }
                }
            });
        }

    };

    var _setNavDropDown = function()
    {
        // $(".listen_fullWidthContent").each(function()
        // {
        //     var $element = $(this);
        //     var $offsetTarget = $element.closest(".mod_isRel");
        //
        //     $element.css("padding", "").css("left", "").css("width", "");
        //
        //     if (_self.viewport.width > _breakpoints.md)
        //     {
        //
        //         var elementWidth = $element.outerWidth(true);
        //
        //         if ($offsetTarget.length > 0 && elementWidth < _self.viewport.width)
        //         {
        //             var offsetLeft = $offsetTarget.offset().left;
        //             var offsetRight = (_self.viewport.width - elementWidth - offsetLeft);
        //
        //             $element.css("width", _self.viewport.width).css("paddingLeft", offsetLeft + "px").css("paddingRight", offsetRight + "px");
        //             if ($element.hasClass("mod_isAbs"))
        //             {
        //                 $element.css("left", (offsetLeft * -1) + "px");
        //             }
        //         }
        //     }
        // });
    };

    var isHighDensity = function()
    {
        return ((window.matchMedia && (window.matchMedia("only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)").matches || window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)").matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
    };

    var isRetina = function()
    {
        return ((window.matchMedia && (window.matchMedia("only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)").matches || window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)").matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    };

    var _changeLazyLoadImages = function()
    {
        $(".widget-MastHeroWithText > img, .widget-text img, .widget-MastPersonPortrait img, .lazyLoadingImages img").each(function()
        {
            var $img = $(this);

            if (_self.viewport.width < _breakpoints.lg
                // && !isRetina()
            )
            {
                $img.attr("src", $img.attr("data-mobilesrc"));
            }
            else
            {
                $img.attr("src", $img.attr("data-desktopsrc"));
            }
            if ($img.attr("src").indexOf("data:image/svg") == -1)
            {
                $img.removeClass("img-empty-placeholder");
            }
            else
            {
                $img.addClass("img-empty-placeholder");
            }
        });
    };

    var _followBasketLink = function()
    {
        $body.find(".toggle-basket-preview:first").click(function()
        {
            var amount = $(this).find(".basket-preview-amount:first");

            if (amount.hasClass("basket-preview-amount isNotEmpty"))
            {
                if (_self.viewport.width > _breakpoints.lg)
                {
                    document.location.href = App.language == "en" ? "/en/basket" : "basket"; // anpassung zu EN, vorher von machart
                }
            }
        });
    };

    var _setReadMoreAutoHeight = function()
    {
        $(".listen_eqHReadMore").each(function()
        {
            var $wrapper = $(this);
            var $sizeElement = $wrapper.children().first();
            var $target = (typeof ($wrapper.attr("data-target")) !== "undefined") ? $($wrapper.attr("data-target")) : false;

            if ($target !== false && $target.length === 1 && $sizeElement.length === 1)
            {
                $sizeElement.css("height", "").removeClass("mod_isAbs");

                var $categoryGridImage = $("#categorygridImage");

                if (_self.viewport.width < _breakpoints.md)
                {
                    var $readMore = $wrapper.find(".do_toggleEqHReadMore.look_readMore");

                    if ($readMore.length > 0)
                    {
                        var $readLessButton = $wrapper.find(".do_toggleEqHReadMore.look_readLess");

                        $readLessButton.show();

                        var targetHeight = parseInt($target.outerHeight(true));
                        var elementSize = parseInt($sizeElement.outerHeight(true));

                        if (typeof $readMore !== "undefined")
                        {
                            if (targetHeight > elementSize)
                            {
                                $readMore.fadeIn();
                            }
                            else
                            {
                                $readMore.fadeOut();
                            }
                        }
                    }
                }
                else
                if (($categoryGridImage.parent().parent().css("width") !== $categoryGridImage.parent().css("width")))
                {
                    var $link = $wrapper.find(".do_toggleEqHReadMore:last");

                    if ($link.length > 0)
                    {
                        var linkOffset = parseInt($link.outerHeight(true));
                        var targetHeight = parseInt($target.outerHeight(true));
                        var elementSize = parseInt($sizeElement.outerHeight(true));
                        var destination = (linkOffset + elementSize);

                        if (targetHeight <= destination)
                        {
                            $sizeElement.addClass("mod_isAbs").css("height", targetHeight);
                        }
                        var $readMore = $sizeElement.parent().find(".do_toggleEqHReadMore");

                        if (typeof $readMore !== "undefined")
                        {
                            if (targetHeight < elementSize)
                            {
                                $readMore.fadeIn();
                            }
                            else
                            {
                                $readMore.fadeOut();
                            }
                        }
                    }
                }
            }
        });
    };

    var _setSingleTabs = function()
    {
        var startTab = 0;
        var $specialTabs = $(".init_specialTabs");
        var $tabLinks = $specialTabs.find(".nav-tabs .nav-link");
        var $tabs = $specialTabs.find(".tab-content .tab-pane");
        var prefix = Math.random().toString(36).substr(2, 9);

        var $templates = $(".render_templates:first");

        if ($("#technical_data").length > 0)
        {
            var $technical = $templates.find("#technical:first");

            var $technicalData = $("#technical_data");

            $technicalData.empty();
            $technicalData.append($technical);
            // $technical.find('[data-toggle="modal"]').on("click", function() {
            //     jQuery.noConflict();
            //     jQuery(this).modal('show');
            // });
        }

        if ($("#zitation_wrapper").length > 0)
        {
            var $zitation = $templates.find("#zitation:first");

            var $zitationWrapper = $("#zitation_wrapper");
            var inhaltZitat = $zitation.find(".look_zitatContent:first");

            if (inhaltZitat.children().length > 0)
            {
                $zitationWrapper.empty();
                $zitationWrapper.append($zitation);
            }
        }

        var skipArray = [];
        var counter = 0;

        $tabs.each(function()
        {
            var self = $(this);

            var p = self.find(".widget .widget-inner p");

            var onlyOneChildren = false;

            if (self.find(".widget .widget-inner").children().length === 1)
            {
                onlyOneChildren = true;
            }

            if (onlyOneChildren && $.trim(p.html()) === "")
            {
                self.addClass("look_forceHidden");
                skipArray.push(counter);
            }
            else
            {
                self.addClass("isInUsage");
                if (counter === startTab)
                {
                    self.addClass("active");
                }
                var group = "group_" + prefix + counter;

                self.attr("data-class", group);
                counter++;
            }
        });

        counter = 0;
        var groupArray = [];

        $tabLinks.each(function()
        {
            var self = $(this);

            if (skipArray.indexOf(counter) !== -1)
            {
                self.addClass("look_forceHidden");
                self.parents("li.nav-item:first").addClass("look_forceHidden");
                skipArray.shift();
            }
            else
            {
                self.addClass("isInUsage");
                if (counter === startTab)
                {
                    self.addClass("active");
                }
                self.attr("data-counter", counter);
                var group = "group_" + prefix + counter;

                groupArray.push(group);
                self.attr("data-class", group);
                self.on("click", function(event)
                {
                    event.preventDefault();
                    _selectActive($(this).attr("data-counter"), groupArray);

                });
                counter++;
            }
        });

        // refresh active tabs and tab links
        $tabs = $specialTabs.find(".tab-content .tab-pane.isInUsage");
        $tabLinks = $specialTabs.find(".nav-tabs .nav-link.isInUsage");

        var goToNext = "Weiter zu";
        var generalGoTo = $("#generalGoTo");

        if (generalGoTo.length > 0)
        {
            goToNext = generalGoTo.attr("value");
        }

        $(".single a[role='tab']").each(function(index, item){
            if($(item).text() == "Beschreibung" && App.language == "en"){
                $(item).text("Description");
            }
            else if($(item).text() == "Größe & Details" && App.language == "en"){
                $(item).text("Size & details");
            }
            else if($(item).text() == "Erfahren Sie mehr" && App.language == "en"){
                $(item).text("Learn more");
            }
            else if($(item).text() == "Unser Versprechen" && App.language == "en"){
                $(item).text("Our Promise");
            }
        });

        if ($tabLinks.length === $tabs.length)
        {
            var numberOfTabs = $tabLinks.length;

            for (var i = 0; i <= numberOfTabs - 1; i++)
            {
                $($tabs[i]).before(
                    "<label data-counter=\"" + i + "\" data-class=\"" + (groupArray[i]) + "\" class=\"init_toggleMobileTab look_mobileAccordeonToggle nav-link-mobile\" data-toggle-open=\"false\">" + ($tabLinks[i].innerHTML) + "<i class=\"look_plusIcon\"></i></label>"
                );
            }

            for (var i = 0; i < numberOfTabs - 1; i++)
            {
                $($tabs[i]).append(
                    "<label class=\"init_followLink look_nextLink nav-link-next\" data-counter=\"" + (i + 1) + "\">" + goToNext + ": " + ($tabLinks[i + 1].innerHTML) + "</label>"
                );
            }
        }

        $tabs.find(".init_followLink").on("click", function()
        {
            var $self = $(this);
            var counter = $self.attr("data-counter");

            _selectActive(counter, groupArray);
            $self.removeClass("init_followLink");
        });

        // open first Tab in mobile
        _selectMobileActive(0, groupArray, false);
        $specialTabs.find(".init_toggleMobileTab:first").data("toggle-open", true);

        var $initMobileTabs = $specialTabs.find(".init_toggleMobileTab");

        $initMobileTabs.on("click", function()
        {
            var $self = $(this);
            var counter = $self.attr("data-counter");
            var isOpen = $self.data("toggle-open");

            isOpen = !!(isOpen);
            _selectMobileActive(counter, groupArray, isOpen);
            $self.data("toggle-open", !isOpen);
        });
        $initMobileTabs.removeClass("init_toggleMobileTab");

        $specialTabs.removeClass("init_specialTabs");
    };

    var _selectActive = function(number, array)
    {
        var $counter = 0;

        number = parseInt(number);
        array.forEach(function(element)
        {
            if ($counter === number)
            {
                $("[data-class=\"" + element + "\"]").addClass("active");
            }
            else
            {
                $("[data-class=\"" + element + "\"]").removeClass("active");
            }
            $counter++;
        });
        return true;
    };

    var _selectMobileActive = function(number, array, isOpen)
    {
        var $counter = 0;

        number = parseInt(number);
        array.forEach(function(element)
        {
            if ($counter === number)
            {
                if (!isOpen)
                {
                    $("[data-class=\"" + element + "\"]").addClass("mobileActive");
                }
                else
                {
                    $("[data-class=\"" + element + "\"]").removeClass("mobileActive");
                }
            }
            $counter++;
        });
        return true;
    };

    var _initFourItemQuestions = function()
    {
        var modalContent = $("#CfourItemQuestionsForm").parents(".m-y-2:first");
        var $cfourWrapper = $("#cfouritemquestions-modal-wrapper");

        $cfourWrapper.find(".modal-body").html(modalContent[0]);
        $cfourWrapper.find(".btn").addClass("do_sendcfouritemquestions btn-primary");
        $cfourWrapper.find("#CfourItemQuestionsForm input[type=\"checkbox\"]").attr("required", "required").attr("name", "privacy-policy-accept").attr("placeholder", "Daten­schutz­erklärung");
    };

    $body.on("click", ".do_sendcfouritemquestions", function(e)
    {
        e.preventDefault();
        $("#cfouritemquestions-modal-wrapper #CfourItemQuestionsForm").ajaxSubmit({
            url: "/sendQuestion",
            type: "post",
            beforeSubmit:
                function(formData, jqForm, options)
                {
                    var doSubmit = true;
                    var privacypolicyacceptWasSet = false;
                    var messages = [];
                    // formData is an array; here we use $.param to convert it to a string to display it
                    // but the form plugin does this for you automatically when it submits the data
                    // console.error(formData);

                    formData.forEach(function(object, key)
                    {
                        if (object.required === true)
                        {
                            if (object.value.length <= 0)
                            {
                                messages.push($("#cfouritemquestions-modal-wrapper [name=\"" + object.name + "\"]").attr("placeholder").replace(/:/g, "").trim() + " ist ein Pflichtfeld. ");
                            }
                        }
                        if (object.name === "privacy-policy-accept")
                        {
                            privacypolicyacceptWasSet = true;
                        }
                    });
                    if (!privacypolicyacceptWasSet)
                    {
                        messages.push($("#cfouritemquestions-modal-wrapper [name=\"privacy-policy-accept\"]").attr("placeholder").replace(/:/g, "").trim() + " ist ein Pflichtfeld. ");
                        doSubmit = false;
                    }
                    if (messages.length > 0)
                    {
                        doSubmit = false;
                        var responseText = "" +
                            "<div class=\"CfourItemQuestionsResponse error\">" +
                            "<div class=\"col-xs-12\">" +
                            "<div class=\"alert alert alert-danger\">" + messages.join("<br>") + "</div>" +
                            "</div>" +
                            "</div>";

                        $("#cfouritemquestions-modal-wrapper .modal-notices").html(responseText);
                    }
                    return doSubmit;
                },
            success: function(responseText, statusText, xhr, $form)
            {
                if (responseText.indexOf("alert-danger") == -1)
                {
                    if (responseText.indexOf("alert") == -1)
                    {
                        responseText = "" +
                            "<div class=\"CfourItemQuestionsResponse success\">" +
                            "<div class=\"col-xs-12\">" +
                            "<div class=\"alert alert-success\">" + responseText + "</div>" +
                            "</div>" +
                            "</div>";
                        $("#cfouritemquestions-modal-wrapper .modal-body").css("display", "none");
                    }
                }
                $("#cfouritemquestions-modal-wrapper .modal-notices").html(responseText);
            }
        });
    });

    var _setViewport = function(type)
    {
        var viewportType = (typeof type === "undefined") ? "outer" : type;
        var viewportHeight = false;
        var viewportWidth = false;

        if (viewportType === "inner")
        {
            if (document.compatMode === "BackCompat")
            {
                viewportHeight = document.body.clientHeight;
                viewportWidth = document.body.clientWidth;
            }
            else
            {
                viewportHeight = document.documentElement.clientHeight;
                viewportWidth = document.documentElement.clientWidth;
            }
        }
        else if (viewportType === "outer")
        {
            var e = window,
                a = "inner";

            if (!("innerWidth" in window))
            {
                a = "client";
                e = document.documentElement || document.body;
            }
            viewportWidth = e[a + "Width"];
            viewportHeight = e[a + "Height"];
        }

        _self.viewport = { width: viewportWidth, height: viewportHeight };
    };

    var _setWindowScroll = function()
    {
        _windowScroll = { top: $(window).scrollTop(), left: $(window).scrollLeft() };
    };

}
